// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__UVk5w","logo":"MainNavigation_logo__SmCip","active":"MainNavigation_active__k4D5S","badge":"MainNavigation_badge__iaAED"};